/**
 *  @class
 *  @function RemoveAll
 */
if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.debouncedOnSubmit = debounce(() => {
        this.onSubmitHandler();
      }, 200);
      this.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }
    onSubmitHandler() {
      this.classList.add('loading');

      // Calzados Modesto®: el campo de notas del pedido solo existe si está
      // activado en los ajustes del carrito. El tema daba por hecho que siempre
      // estaba y, al no encontrarlo, se quedaba el círculo girando sin vaciar nada.
      const notas = document.getElementById('mini-cart__notes');

      fetch(`${theme.routes.cart_clear_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': notas ? notas.value : ''
        })
      }).then(() => {
        if (this.drawer) {
          this.drawer.refresh();
        }
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        // Pase lo que pase, se quita el círculo de carga
        this.classList.remove('loading');
      });
    }
  }
  customElements.define('remove-all', RemoveAll);
}